import { Equipment_Extra } from './equipment_Extra';

export class Equipment {
  id = '';
  location_Id: number;
  description: string;
  serial_Num: string;
  asset_Num: string;
  swl: string;
  manufacturer_Id: number;
  date_Of_Manufacture: string;
  category_Id: number;
  other_Details: string;
  expired = false;
  is_edit = false;

  extras = [];
}
